@if (isEditMode) {
  <h2 mat-dialog-title>
    <i class="fa fa-edit" aria-hidden="true"></i>&nbsp; Edit Buyers Group
  </h2>
} @else {
  <h2 mat-dialog-title>
    <i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Add Buyers Group
  </h2>
}
<form [formGroup]="formGroup" (submit)="save()">
  <mat-dialog-content gdColumns="repeat(1, minmax(0, 1fr))" gdGap="0 15px">
    <mat-form-field>
      <mat-label>Group Name</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>
    <div gdColumns="repeat(3, minmax(0, 1fr))" gdGap="15px">
      <tc-select-search placeholder="Dest Country" [multiple]="true" [group]="formGroup" ctrlName="destCountry"
        [items]="countries$ | async" bindValue="code" bindLabel="name"></tc-select-search>
      <tc-select-search placeholder="Dest Location" [multiple]="true" [group]="formGroup" ctrlName="destLocation"
        [items]="locations$ | async" bindValue="location_id" bindLabel="name"></tc-select-search>
      <tc-select-search placeholder="Primary Acct Manager" [multiple]="true" [group]="formGroup" ctrlName="primaryAcctManager"
        [items]="managers$ | async" bindValue="user_id" bindLabel="fullname"></tc-select-search>
    </div>
    <div class="add-buyer-row">
      @if (filteredBuyers$ | async; as filteredBuyers) {
        <tc-select-search #buyersSelect [placeholder]="'Select Buyers (' + filteredBuyers.length + ' buyers found)'" [multiple]="true" [group]="formGroup" ctrlName="buyers"
          [items]="filteredBuyers" bindValue="id" bindLabel="name"></tc-select-search>
      }
      <button mat-raised-button type="button" color="primary" (click)="addSelectedBuyers()"
        [disabled]="!(selectedInSelectbox$ | async)">
        + Add ({{ (selectedInSelectbox$ | async) || 0 }})
      </button>
    </div>
    @if (selectedBuyersDataSource.data.length) {
      <div class="buyers-table-wrapper">
      <table mat-table [dataSource]="selectedBuyersDataSource" matSort class="buyers-table">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="checkbox-cell">
            <mat-checkbox (change)="toggleAllRows(selectedBuyersDataSource.data)"
              [checked]="selection.selectAllStatus(selectedBuyersDataSource.data) === 'all'"
              [indeterminate]="selection.selectAllStatus(selectedBuyersDataSource.data) === 'some'">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="checkbox-cell">
            <mat-checkbox
              [checked]="selection.isSelected(row)"
              (click)="onCheckboxClick($event, row)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Buyer Name</th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>
        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
          <td mat-cell *matCellDef="let row">{{ row.country }}</td>
        </ng-container>
        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
          <td mat-cell *matCellDef="let row">{{ row.location }}</td>
        </ng-container>
        <ng-container matColumnDef="primaryAccountManager">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Primary Account Manager</th>
          <td mat-cell *matCellDef="let row">{{ row.primaryAccountManager }}</td>
        </ng-container>
        <ng-container matColumnDef="incoterm">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="incoterm-cell">Incoterm</th>
          <td mat-cell *matCellDef="let row" class="incoterm-cell">{{ row.incoterm }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-cell"></th>
          <td mat-cell *matCellDef="let row" class="actions-cell">
            <button mat-icon-button type="button" (click)="removeBuyer(row.id)">
              <mat-icon class="fa fa-trash-can"></mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="selectedBuyersColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: selectedBuyersColumns;"></tr>
      </table>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <span>{{ (addedBuyerIds$ | async)?.length || 0 }} Members</span>
    <button class="delete-button" mat-raised-button type="button" color="warn" (click)="removeSelectedBuyers()"
      [disabled]="!selection.selectedIds.size">Delete ({{ selection.selectedIds.size }})</button>
    <span class="spacer"></span>
    <button mat-button type="button" (click)="cancel()">Close</button>
    <button mat-raised-button type="submit" color="primary">
      <i class="fa fa-fw fa-save" aria-hidden="true"></i>
      {{ isEditMode ? 'Save Group' : 'Add Group' }}
    </button>
  </mat-dialog-actions>
</form>
